import { fetchStaffById } from "@/api/customer"

const state = {
  profile: null,
  loading: false,
  promise: null
}

function normalizeProfile(raw) {
  if (!raw) return null
  return raw?.data ?? raw
}

export function getCurrentStaffProfile() {
  return state.profile
}

export function getCurrentTopDepartmentId() {
  const p = state.profile
  const dept = p?.topDepartment
  if (dept === null || dept === undefined || dept === "") return null
  if (typeof dept === "object") return dept.weId ?? dept.id ?? dept.topDepartmentId ?? null
  return dept
}

export async function initCurrentStaffProfile() {
  if (state.profile) return state.profile
  if (state.promise) return state.promise
  state.loading = true
  state.promise = fetchStaffById()
    .then(res => {
      state.profile = normalizeProfile(res)
      return state.profile
    })
    .catch(() => null)
    .finally(() => {
      state.loading = false
      state.promise = null
    })
  return state.promise
}

export async function ensureCurrentStaffProfile() {
  if (state.profile) return state.profile
  return initCurrentStaffProfile()
}

